export type JobStatusGroup = 'active' | 'draft' | 'history';

export function getJobStatusGroup(status: string | null | undefined): JobStatusGroup {
  if (status === 'active') return 'active';
  if (status === 'draft') return 'draft';
  return 'history';
}

export const isActiveJobStatus = (status: string | null | undefined) =>
  getJobStatusGroup(status) === 'active';

export const isDraftJobStatus = (status: string | null | undefined) =>
  getJobStatusGroup(status) === 'draft';

export const isPublishedJobStatus = (status: string | null | undefined) =>
  getJobStatusGroup(status) !== 'draft';

export function groupJobsByStatus<T extends { status: string | null | undefined }>(jobs: T[]) {
  return jobs.reduce<Record<JobStatusGroup, T[]>>((groups, job) => {
    groups[getJobStatusGroup(job.status)].push(job);
    return groups;
  }, { active: [], draft: [], history: [] });
}
